"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKey = exports.normalize = exports.TelemetryHook = void 0;
var shared_1 = require("@cian/peperrors/shared");
var circuitBreakerError_1 = require("../../errors/circuitBreakerError");
var TelemetryHook = /** @class */ (function () {
    function TelemetryHook(params) {
        this.telemetry = params.telemetry;
        this.isEnabled = params.context.telemetryEnabled;
        this.telemetryKey = getKey(params.context.requestedServerName, params.context.simplifiedPath);
    }
    TelemetryHook.prototype.onRequest = function () {
        this.startDate = Date.now();
    };
    TelemetryHook.prototype.onResponse = function () {
        if (this.isEnabled) {
            this.telemetry.timer(this.telemetryKey, this.timeDiff);
            this.telemetry.increment("".concat(this.telemetryKey, ".success"));
        }
    };
    TelemetryHook.prototype.onError = function (error) {
        if (this.isEnabled) {
            if (error instanceof circuitBreakerError_1.CircuitBreakerError) {
                this.telemetry.increment("".concat(this.telemetryKey, ".fail.circuit_breaker"));
                return;
            }
            if (error instanceof shared_1.HttpTimeoutError) {
                this.telemetry.timer(this.telemetryKey, this.timeDiff);
                this.telemetry.increment("".concat(this.telemetryKey, ".fail.timeout"));
                return;
            }
            if (error instanceof shared_1.HttpCancelError) {
                this.telemetry.timer(this.telemetryKey, this.timeDiff);
                this.telemetry.increment("".concat(this.telemetryKey, ".fail.cancel"));
                return;
            }
            if (error instanceof shared_1.HttpBadStatusCodeError) {
                this.telemetry.timer(this.telemetryKey, this.timeDiff);
                this.telemetry.increment("".concat(this.telemetryKey, ".fail.http_error_").concat(error.statusCode));
                return;
            }
            this.telemetry.increment("".concat(this.telemetryKey, ".fail.error_").concat(normalize(error.name)));
        }
    };
    Object.defineProperty(TelemetryHook.prototype, "timeDiff", {
        get: function () {
            return Date.now() - this.startDate;
        },
        enumerable: false,
        configurable: true
    });
    return TelemetryHook;
}());
exports.TelemetryHook = TelemetryHook;
function normalize(str) {
    return str.toLowerCase().replace(/\W+/g, '-').replace(/^-+/, '').replace(/-+$/, '') || '-';
}
exports.normalize = normalize;
function getKey(host, path) {
    return ['external', 'http', normalize(host), normalize(path)].join('.');
}
exports.getKey = getKey;
//# sourceMappingURL=TelemetryHook.js.map